import {TweenMax, Power3} from 'gsap/all';
import gsap from 'gsap'
import {ScrollToPlugin} from 'gsap/all'

gsap.registerPlugin(ScrollToPlugin)

export default class WooCommerceArchiveScroll {

    constructor() {
        if (this.setVars()) {
            this.setEvents();
        }
    }

    setVars() {

        this.settings = {
            'main': '.post-type-archive-product',
            'click': '.lmp_button',
            'wrapper': '.product',
        };

        this.scrolls = document.querySelectorAll(`${this.settings.main}`);

        if (!this.scrolls) return;

        return true;
    }

    setEvents() {
        this.scrolls.forEach((item) => {
            item.querySelector(`${this.settings.click}`).addEventListener('click', (e) => {
                // e.preventDefault();
                // e.stopPropagation();
                const element = document.querySelector(this.settings.wrapper).getBoundingClientRect();

                TweenMax.to(window, 1, {scrollTo: {y: element.bottom}, ease: Power3.easeInOut})
            })
        });
    }
}
